import projectLayout from './container/ProjectLayout';

export const ProjectLayout = projectLayout;
